export const colors = {
  green: "#6ad761",
  blue: "#41c3f6",
  pink: "#ff69b4",
  red: "#ea5455",
  gray: "#777777",
};
